import { stateAbbreviations } from 'app/SeFriendly/validateUsaState'
import { AddressComponentMap, NameTypes } from './constants'

export const zipcodeValidation = (e: string): boolean => {
  if (/^\d*\.?\d*$/.test(e) && e.length <= 5) {
    return true
  } else {
    return false
  }
}

export const getAddressComponent = (
  result: GeocoderResult,
  component: string,
  nameType: string
): string => {
  const item = result.address_components
  const code = item.filter((addressComponents) =>
    addressComponents.types.includes(component)
  )
  let res = ''

  if (code.length > 0) {
    res = code
      .map((address) => address[nameType])
      .reduce((addressObject, t) => addressObject.concat(t))
  }

  return res
}

export const getZipCode = (result: GeocoderResult): string => {
  return getAddressComponent(
    result,
    AddressComponentMap.ZIPCODE,
    NameTypes.LONG
  )
}

export const getCity = (result: GeocoderResult): string => {
  return getAddressComponent(result, AddressComponentMap.CITY, NameTypes.LONG)
}

export const getState = (result: GeocoderResult): string => {
  return getAddressComponent(result, AddressComponentMap.STATE, NameTypes.SHORT)
}

export const getCountry = (result: GeocoderResult): string => {
  return getAddressComponent(
    result,
    AddressComponentMap.COUNTRY,
    NameTypes.SHORT
  )
}

export const getLocationDataFromResult = (
  result: GoogleLocationResult,
  withFullStateName?: boolean
): LocationData => {
  const { lat, lng, main_text, secondary_text } = result
  const state = getState(result)
  const stateFullName = stateAbbreviations[state] || ''

  let location = `${!!main_text ? main_text.trim() : ''}${
    !!secondary_text ? `, ${secondary_text.trim()}` : ''
  }`

  // this returns a location string with full state name
  // eg. "Miami, FL, USA" ==> "Miami, Florida"
  // eg. "Texas City, TX, USA" ==> "Texas City, Texas"
  // eg. "California, USA" ==> "California"
  if (withFullStateName && stateFullName && main_text) {
    location =
      main_text === stateFullName ? main_text : `${main_text}, ${stateFullName}`
  }

  return {
    state: state,
    longitude: lng,
    latitude: lat,
    location,
  }
}
